import { change } from 'redux-form';
import { FORM_NAME, FIELD_NAMES } from './constants';

export const resetCustomMessage = () =>
    change(FORM_NAME, FIELD_NAMES.customMessage, '');
